import type {Activities} from '@gaia/types';
import fetchJSON from '@gaia/utils/fetchJSON';
import once from 'lodash/once';

// activites.json is designed to rarely change. fetchActivities should always be memoized in some way if this function needs to change in the future.
export default once(async (): Promise<Activities | undefined> => {
    const url = '/api/objects/activities/';
    try {
        const activities = await fetchJSON(url);
        return activities;
    } catch (e) {
        console.error(e);
    }
});
